import React, { FC, useMemo } from 'react'

import { ambassadorHttpClient } from '../../../api/httpClient'
import { BusinessTermService } from '../../reusable/Category/api/BusinessTermService'
import { WixMobileCategory as WixMobileCategoryUnwrapped } from './WixMobileCategory'

export const WixMobileCategory: FC = () => {
  const businessTermService = useMemo(() => new BusinessTermService(ambassadorHttpClient), [])
  return <WixMobileCategoryUnwrapped businessTermService={businessTermService} />
}
